export const fr = {
  volunteerActivityPage: {
    page_title: 'Mes activités bénévoles',
    table: {
      title: 'Mes activités bénévoles',
      subtext: 'Gérez vos activités bénévoles et les heures soumises',
      columns: {
        name: 'Nom',
        date: 'Date',
        hours: 'Heures',
        location: 'Lieu',
        status: 'Statut',
        nonprofit: 'Organisation à but non lucratif',
      },
      status: {
        cancelled: 'Annulé',
        upcoming: 'À venir',
        awaiting_feedback: 'En attente de commentaires',
        completed: 'Terminé',
        submitted: 'Soumis',
        virtual: 'Virtuel',
        approved: 'Approuvé',
        pending: 'En attente',
        denied: 'Refusé',
        hours_required: 'Heures requises',
        waitlisted: '#{{position}} sur la liste d\'attente',
        none: 'Aucun',
        request_prefix: 'Demande',
      },
      community_action: 'Action communautaire',
      custom_event: 'Événement personnalisé de {{userName}}',
      outside_hours: '(En dehors des heures de travail)',
      empty_state: {
        title: 'Aucune activité bénévole pour le moment',
        description:
          "Il semble que vous n'ayez pas encore participé à des activités bénévoles.\nAllez sur le tableau de bord de votre entreprise pour trouver un événement bénévole!",
      },
      filters: {
        all: 'Tous',
        purposely: 'Purposely',
        my_hours: 'Mes heures',
        type: 'Type',
        status: 'Statut',
        type_prefix: 'Type : ',
        status_prefix: 'Statut : ',
        start: 'Début',
        end: 'Fin',
      },
      actions: {
        edit: 'Modifier',
        delete: 'Supprimer',
        give_feedback: 'Donner un avis',
        visit_page: 'Visiter la page',
        view_details: 'Voir les détails',
        add: 'Ajouter',
      },
    },
    search_placeholder: 'Rechercher des activités bénévoles',
    add_hours_button: 'Ajouter des heures',
    reservation_hours: {
      subtitle: "Enregistrez vos heures de bénévolat pour l'événement",
      submit: 'Ajouter',
      nonprofit: 'Organisme',
      nonprofit_label: 'Organisme',
      nonprofit_url: 'Site web de l\'organisme (facultatif)',
      location_label: 'Lieu',
      location_col: 'Lieu',
    },
    add_hours: {
      title: 'Ajouter des heures',
      description:
        "Ajoutez des heures pour du bénévolat en dehors de Purposely. Visible pour vous et les administrateurs de l'entreprise pour le suivi de l'impact.",
      form: {
        required: 'Requis',
        confirm_required:
          'Je comprends que ces heures devront être à nouveau approuvées si elles sont modifiées.',
        virtual_notice:
          'Soit le lieu, soit l’événement virtuel doit être sélectionné',
        date: 'Date',
        hours: 'Heures',
        hours_placeholder: 'ex. 3,5',
        virtual_event: 'Événement virtuel',
        location: 'Lieu',
        location_placeholder: 'ex. Vancouver, BC',
        nonprofit: 'Organisation à but non lucratif',
        nonprofit_placeholder: 'ex. Quest Food Exchange',
        cause: 'Cause',
        outside_work_hours:
          'Le bénévolat a été effectué en dehors des heures de travail',
        solo_confirmation:
          "Je confirme que j'ajoute des heures pour un événement bénévole en solo",
        submit: 'Soumettre',
        error_confirmation:
          "Veuillez confirmer qu'il s'agit d'un événement en solo",
        details: 'Détails',
        details_hint:
          'Fournissez des informations supplémentaires sur votre activité bénévole et ce que vous faisiez',
      },
      success: 'Heures ajoutées',
      confirm_step: {
        title: 'Heures soumises',
        title_edit: 'Heures modifiées',
        description: 'Vos heures de bénévolat ont été soumises avec succès.',
        description_review:
          "Un e-mail vous sera envoyé une fois qu'un administrateur de l'entreprise aura examiné votre soumission.",
        description_edit:
          'Vos heures de bénévolat ont été modifiées avec succès.',
      },
    },
    details_modal: {
      title: 'Détails',
      close: 'Fermer',
      header:
        "Un administrateur de l'entreprise a refusé vos heures de bénévolat personnalisées pour la raison suivante :",
    },
    delete_modal: {
      title: 'Supprimer les heures personnalisées',
      message:
        'Êtes-vous sûr de vouloir supprimer ces heures de bénévolat personnalisées?',
      confirm: 'Oui, supprimer',
      cancel: 'Annuler',
      success: 'Vos heures personnalisées ont été supprimées avec succès',
      error: 'Impossible de supprimer. Veuillez réessayer plus tard.',
    },
  },
}
